export const MANAGE_DASHBOARDS_PATH = "/app/dashboard/manage-dashboards";
export const dashboardBuilderPath = (dashboardId) =>
  `${MANAGE_DASHBOARDS_PATH}/${dashboardId}`;
export const DASHBOARD_BOARDS_PATH = "/app/dashboard/boards";
export const dashboardBoardPath = (dashboardId) =>
  `${DASHBOARD_BOARDS_PATH}/${dashboardId}`;

// TODO: the backend does not send this grant yet. Until it does, a missing key
// keeps the menu, page and actions available; only an explicit value limits them.
const getManageDashboardsAction = (grants) =>
  grants?.module?.dashboard?.menu?.["manage-dashboards"]?.action;

export const canViewManageDashboards = (grants) =>
  getManageDashboardsAction(grants) !== "deny";

export const canEditManageDashboards = (grants) => {
  const action = getManageDashboardsAction(grants);
  return !action || action === "edit";
};

/* ------------------------------ Builder grid ------------------------------ */
export const GRID_COLS = 12;
export const ROW_HEIGHT = 40;
export const GRID_GAP = 16;
export const MIN_W = 2;
export const MIN_H = 3;
// Converts a widget's default pixel size into grid units.
export const REF_COL_WIDTH = 100;

// Shape of dashboard-widget `configuration` written by this page. The backend
// stores it as-is (Mixed); bump the version when the shape changes.
export const CONFIGURATION_VERSION = 1;

// Mirrors widget.available_filters[].type defined in the backoffice.
export { FILTER_TYPES } from "app/components/modules/widgets/filters";
